import { render, staticRenderFns } from "./MenuItemCard.vue?vue&type=template&id=5a918696&scoped=true&"
import script from "./MenuItemCard.vue?vue&type=script&lang=js&"
export * from "./MenuItemCard.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemCard.vue?vue&type=style&index=0&id=5a918696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a918696",
  null
  
)

export default component.exports